import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { RdsToastService } from '@rds/angular-components';
import { catchError } from 'rxjs';

import { isMaintenanceResponse } from '../maintenance/maintenance.model';
import { MaintenanceService } from '../maintenance/maintenance.service';

export const httpErrorInterceptor: HttpInterceptorFn = (req, next) => {
  const rdsToastService = inject(RdsToastService);
  const maintenanceService = inject(MaintenanceService);
  return next(req).pipe(
    catchError(error => {
      // 401 - unauthorized and 403 - forbidden is processed by auth-error interceptor;
      // maintenance is shown on its own screen instead of a toast
      if (
        !(
          error.status === 401 ||
          error.status === 403 ||
          isRoomAccessDenied(error) ||
          error.url?.includes('/redirect') ||
          maintenanceService.active() ||
          isMaintenanceResponse(error)
        )
      ) {
        handleHttpError(error, rdsToastService);
      }

      throw error;
    })
  );
};

const isRoomAccessDenied = (error: HttpErrorResponse): boolean =>
  error.status === 410 && /\/rooms\/[^/?#]+$/.test(error.url ?? '');

const handleHttpError = (err: HttpErrorResponse, toast: RdsToastService) => {
  const message = err.url?.includes('/auth/v1/auth')
    ? 'Authorization error occurred'
    : (err.error?._embedded?.errors[0]?.message ??
      err.message ??
      'Unexpected error occurred');
  toast.error(message, 'An error occurred', {
    timeOut: 30000,
  });
};
